/** @format */

import React, { useEffect, useRef, useState } from "react";
import WithAuth from "../../auth/PdfEditor/withAuth";
// import WithAuth from "../../../auth/withAuth";
import MainDrawer from "../../components/PdfEditor/Modal/MainDrawer"
import PdfViewport from "../../components/PdfEditor/Pdf-Rederer/PdfViewport";
import { useDispatch, useSelector } from "react-redux";
import { updateAllCoordinates } from "../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import { pdfToolApi } from "../../services/PdfEditor/pdfToolApi";
import DocumentsTable from "../../components/PdfEditor/Pdf-Utils/DocumentsTable";
import UploadDocument from "../../components/PdfEditor/Pdf-Utils/UploadDocument";
import { getDocumentsDetailsApi } from "../../store/reducers/pdfeditor/getDocumentsDetailSlice";
import { Stack, Box, TextField, Typography, Divider, Button } from "@mui/material";
import { toast } from "react-toastify";
import Loader from "../../components/PdfEditor/Loader/Loader";
import debounce from "lodash.debounce";

const PdfEditor = () => {
  const dispatch = useDispatch(); 
  // const { uploadedDocument } = useSelector((state) => state.pdfDetails);
  const { uploadedDocument} = useSelector((state) => state.uploadDocument);
  
  // const  { documentData }  = useSelector((state) => state.getDocumentsDetail);
  const [loader, setLoader] = useState(false);
  const [searchDoc, setSearchDoc] = useState([]);
  const searchRef = useRef("");

  const { profileData } = useSelector((state) => state.profile);
  console.log("profileData",profileData)
  console.log("uploadedDocument",uploadedDocument)
  // console.log("documentData",documentData) 
  const [open, setOpen] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [document, setDocument] = useState(null);

  // const handleSearch = debounce(() => {
  //   const searchTerm = searchRef.current?.value?.toLowerCase() || "";
  //   if (!searchTerm) {
  //     setSearchDoc(documentData?.data || []);
  //     return;
  //   }

  //   const filteredDocument =
  //   //   documentData?.data?.filter((item) =>
  //   //     item?.document_id?.toLowerCase()?.includes(searchTerm)
  //   //   ) || [];
  //   // setSearchDoc(filteredDocument);
  // }, 300);

  // useEffect(() => {
  //   if (documentData?.data) {
  //     setSearchDoc(documentData?.data);
  //   }
  // }, [documentData?.data]);

  // useEffect(() => {
  //   const debouncedSearch = debounce(() => {
  //     const searchTerm = searchRef.current?.value?.toLowerCase() || "";
  //     if (!searchTerm) {
  //       // setSearchDoc(documentData?.data || []);
  //       return;
  //     }
  
  //     // const filteredDocument =
  //     //   documentData?.data?.filter((item) =>
  //     //     item?.document_id?.toLowerCase()?.includes(searchTerm)
  //     //   ) || [];
  //     // setSearchDoc(filteredDocument);
  //   }, 300);
  
  //   return () => debouncedSearch.cancel();
  // }, [documentData?.data]);
  



  useEffect(() => {
    if (uploadedDocument) {
      setOpen(true);
    } else {
      setOpen(false);
      dispatch(updateAllCoordinates([]));
    }
  }, [uploadedDocument]);

  const handleSubmit = async () => {
    if (!document) return toast.error("Upload Document !");
    setLoader(true);
    const formData = new FormData();
    formData.append("document", document);
    pdfToolApi
      .refreshToken()
      .then((res) => {
        pdfToolApi.uploadPdf(formData, res.access).then((response) => {
          if (response.status) {
            setOpenModal(false);
            setDocument(null);
            setLoader(false);
            toast.success(response.message);
            pdfToolApi.refreshToken().then((res) => {
              dispatch(getDocumentsDetailsApi(res?.access));
            });
          } else {
            toast.error(response.message);
            setLoader(false);
          }
        });
      })
      .catch((error) => {
        toast.error(error.message);
        setLoader(false);
      });
  };

  let headers = [
    { id: 1, label: "Document ID" },
    { id: 2, label: "Date-Time" },
    { id: 3, label: "Actions" },
  ];

  if (loader) {
    return <Loader />;
  }
  return (
    <>
      <Stack spacing={2}>
        <PdfViewport open={open} setOpen={setOpen} />
        {/* <MainDrawer drawerData={<PdfViewport open={open} setOpen={setOpen} />} setOpen={setOpen} open={open} /> */}
      </Stack>
    </>
  );
};

export default PdfEditor;
